import { useNavigate } from "react-router-dom"
import { makeStyles } from "tss-react/mui"
import { AdminHomeCard, AdminHomeCardGroup, AdminHomeCardGroups } from "../../../admin/components/AdminHomeCard"
import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import { SUPPORT_ENTITIES_ROUTE } from "../../../../constants/routes"

const useStyles = makeStyles()((_theme) => ({
    page: {
        paddingTop: "3rem",
    },
}))
type Props = Readonly<{}>

export function SupportAdminHome({}: Props) {
    const { classes } = useStyles()
    const navigate = useNavigate()
    return (
        <div className={classes.page}>
            <AdminHomeCardGroups>
                <LocalizedStrict id="support-admin-entities-card-group" attrs={{ title: true }}>
                    <AdminHomeCardGroup title="Entities">
                        <LocalizedStrict id="support-admin-entities-card" attrs={{ title: true, description: true }}>
                            <AdminHomeCard
                                title="Entities"
                                description="Manage devices across your merchants."
                                onShowAllClick={() => navigate(SUPPORT_ENTITIES_ROUTE)}
                            />
                        </LocalizedStrict>
                    </AdminHomeCardGroup>
                </LocalizedStrict>
            </AdminHomeCardGroups>
        </div>
    )
}
